<div class="row">
    <div class="col">
        <h6 class="pt-5px"><strong>Admin configuration</strong></h6>
    </div>
</div>
<form [formGroup]="form">
    <div class="modal-body">
        <fieldset class="field-container">
            <legend class="field-container-title">For Immigration team members</legend>
            <div class="form-row">
                <div class="form-group col-md-3">
                    <label>
                        <input formControlName="disableIC" class="check-input mt-2" type="checkbox" />
                        Disable IC role access
                    </label>
                </div>
                <div class="form-group col-md-3">
                    <label>
                        <input formControlName="disablePTC" class="check-input mt-2" type="checkbox" />
                        Disable PJC role access
                    </label>
                </div>
            </div>
        </fieldset>
        <div class="col-12 text-center mt-3">
            <button class="btn btn-primary me-2" (click)="onUpdate()" > Update </button>
        </div>
    </div>
</form>